import React, { useEffect, useState } from 'react';

export const Navigation = (props) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top${
        scrolled ? '' : ' navbar-overlay'
      }`}
    >
      <div className="container">
        <div className="navbar-header">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              {' '}
              <span className="sr-only">Toggle navigation</span>{' '}
              <span className="icon-bar"></span>{' '}
              <span className="icon-bar"></span>{' '}
              <span className="icon-bar"></span>{' '}
            </button>

            <a
              className="navbar-brand"
              href="/"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                color: '#fff',
                textDecoration: 'none',
                padding: '6px 0',
              }}
            >
              <span style={{ fontWeight: 700, fontSize: 18 }}>
                Zanari Analytics
              </span>
            </a>
          </div>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul
            className={`nav navbar-nav navbar-right${
              scrolled ? '' : ' navbar-nav-overlay'
            }`}
          >
            <li>
              <a href="#features" className="page-scroll">
                What We Offer
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Our Solutions
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            <li>
              <a href="#team" className="page-scroll">
                Portfolio
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
